import { Injectable } from '@angular/core'
import { CastServer } from './cast-server'
import { LogService } from 'htv-lib'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { catchError, EMPTY, map, Observable, of } from 'rxjs'
import { GoogleCastProxyServerState } from '../interfaces/local-googlecast'
import { GoogleCastConfig } from '../interfaces/htv-config'

@Injectable({
  providedIn: 'root',
})
export class CastVDCast implements CastServer {
  proxyStatusEndpoint?: string

  constructor(
    private httpClient: HttpClient,
    private logService: LogService
  ) {
    // do nothing
  }

  init(config?: GoogleCastConfig): void {
    this.logService.info('[CastVDCast] Init')
    this.proxyStatusEndpoint = config?.proxyStatusEndpoint ?? undefined
  }

  queryProxyStatus(): Observable<GoogleCastProxyServerState | undefined> {
    if (!this.proxyStatusEndpoint) {
      return of(undefined)
    }

    return this.httpClient.get(this.proxyStatusEndpoint).pipe(
      map((res: any) => {
        if (res) {
          return {
            hasError: false,
            pairingStatus: res?.pairingStatus ?? false,
            code: res?.code,
            qrcodeUrl: res?.qrcodeUrl,
            registerUrl: res?.registerUrl,
            wifiSSID: res?.wifiSSID,
          } as GoogleCastProxyServerState
        } else {
          this.logService.debug(`[CastVDCast] (status) Received empty response from VDCast server`)
          return {
            hasError: true,
            pairingStatus: false,
            errorKey: 'EMPTY_RESPONSE',
          } as GoogleCastProxyServerState
        }
      }),
      catchError((err: HttpErrorResponse) => {
        const state: GoogleCastProxyServerState = {
          hasError: true,
          pairingStatus: false,
        }
        switch (err.status) {
          case 0:
            state.errorKey = 'SERVER_UNREACHABLE'
            break
          case 404:
            state.errorKey = 'NOT_FOUND'
            break
          case 500:
            state.errorKey = 'SERVER_ERROR'
            break
          default:
            state.errorKey = undefined
            break
        }
        this.logService.error(
          `[CastVDCast] Could not retrieve GoogleCast proxy status, error = ${err?.message} (${state.errorKey})`
        )
        return of(state)
      })
    )
  }

  sendCheckoutToProxy(): Observable<void> {
    if (!this.proxyStatusEndpoint) {
      return of(undefined)
    }

    const proxyCheckoutEndpoint = this.proxyStatusEndpoint.replace('/status', '/checkout')

    return this.httpClient.get(proxyCheckoutEndpoint).pipe(
      catchError(err => {
        this.logService.error(`[CastVDCast] Could not call checkout to proxy, error = ${err?.message}`)
        return EMPTY
      }),
      map(() => undefined)
    )
  }
}
